<template>
  <app-layout title="Builder">
    <PageTitle :headerTitle="title"> </PageTitle>
    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-2 py-2">
          <DxTabPanel   v-model:selected-index="selectedIndex">

            <DxItem icon="fields" title="Relationships">
              <template #default>
              <FieldList @send="recieve" :modulekey="modulekey" :studio="studio" :slug="slug" ref="realtionships_builder_list" @callAddTab="addTab(target)"/>
              </template>
            </DxItem>


            <DxItem icon="fields" title="Add Relationships">
              <template #default>
              <AddField  @send="recieve" :modulekey="modulekey" :tabData="tabData" :edit="editmode" :studio="studio" :slug="slug" ref="realtionships_builder_add_field" />                                        
              </template>          
              </DxItem>

          </DxTabPanel>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import FieldList from "@/components/builder/relationships/relationship_builder_list.vue";
import AddField from "@/components/builder/relationships/relationship_builder_add.vue";
import AddDropdown from "@/components/builder/fields/fields_builder_add_dropdown.vue";

import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import DxDataGrid from "devextreme-vue/data-grid";
import PageTitle from "@/Layouts/PageTitle.vue";

export default {
  components: {
    DxTabPanel,
    DxItem,
    DxDataGrid,
    FieldList,
    AddField,
    AddDropdown,
    AppLayout,
    PageTitle,
  },

  props: ["modulekey", "studio","slug"],
  data() {
    return {
      title: "Add Relationships",
      selectedIndex: 0,
       tabData: {},
       editmode: false,
    };
  },
   methods: {
       recieve(data) {
            this.selectedIndex = data.tabindex;
            console.log("RECIEVED DATA",data);
             this.tabData = data.tabData;
             this.editmode = data.editmode;
            // this.ddmode = data.ddmode;
            // this.ddData = data.ddData;
            // this.FieldTitle = (this.editmode) ? "Edit Field" : "Add Field";
            // this.ddTitle = (this.ddmode) ? "Edit Dropdown" : "Add Dropdown";

        },
   }
};
</script>
